import React from "react";
import { useTranslation } from "react-i18next";

import { ExerciseId } from "../types";
import { useFavouritesAndExcluded } from "../utils/useFavouritesAndExcluded";
import ExercisesEditList from "./ExercisesEditList";

const FavouritesList: React.FC = () => {
    const { t } = useTranslation();
    const { favourites, setFavourite } = useFavouritesAndExcluded();

    const handleDeleteClick = (id: ExerciseId) => {
        setFavourite(id, false);
    };

    return (
        <ExercisesEditList
            header={t("favourites")}
            noExercisePlaceholder={t("no_favourite_exercises")}
            ids={favourites}
            onDelete={handleDeleteClick}
        />
    );
};

export default FavouritesList;
